import { Badge, Box, Group, Stack, Text } from '@mantine/core';
import { getEnumColor, getEnumLabel } from '../../../../../utils/enumUtils';

import { DATA_FILE_STATUSES } from '../../../../common/enums/enums';

const StatusCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    const badgeLabel = getEnumLabel(DATA_FILE_STATUSES, rowData.status);
    const badgeColor = getEnumColor(DATA_FILE_STATUSES, rowData.status);
    return (
        <Badge
            color={badgeColor}
            size={'sm'}>
            {badgeLabel}
        </Badge>
    );
};

const StatusColumn = () => ({
    accessorKey: 'status',
    header: 'Status',
    size: 2,
    minSize: 60,
    Cell: ({ cell }) => <StatusCell cell={cell} />,
});
export default StatusColumn;
